module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-i-pad@3x.2ab35c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-i-pad@3x.png
// module id = DIK6
// module chunks = 18